import { get } from '@/redux/requests/api.js';
import collabRequest from '@/redux/requests/collabRequest.js';

const collabGet = (url, config = {}) => get(url, config);
const collabPost = (resourceType, config = {}) => collabRequest('POST', resourceType, config);
const collabPut = (resourceType, config = {}) => collabRequest('PUT', resourceType, config);
const collabDel = (resourceType, config = {}) => collabRequest('DELETE', resourceType, config);

export default {
  del: collabDel,
  delete: collabDel,
  get: collabGet,
  post: collabPost,
  put: collabPut
};
